// this function takes a value and formats it to thousands

function priceFormatter( sum ) {
  if(isNaN(sum) || sum === null) {
    return null
  }
  const formattedSum = sum?.toString()?.replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
  return formattedSum
}

export default priceFormatter;
